// Shared strings of the 2026-10-03 ledger reports (export mixin, print
// header, AccountPicker, page stubs). Owned by the reports scaffold:
// report pages read them, never edit them. Path: finance.reports2.common.*
export default {
  companyFallback: "Snap Drive",
  company: "Company",
  period: "Period",
  from: "From",
  to: "To",
  date: "Date",
  currency: "Currency",
  currencySyp: "SYP",
  issuedAt: "Issued at",
  page: "Page",
  of: "of",
  total: "Total",
  refresh: "Refresh",
  apply: "Apply",
  exportExcel: "Excel",
  exportCsv: "CSV",
  print: "Print / PDF",
  expandAll: "Expand all",
  collapseAll: "Collapse all",
  showAll: "Show all",
  perPage: "Rows per page",
  noData: "No data",
  noMovements: "No movements in this period",
  tooManyRows: "More than 10,000 lines - please narrow the period",
  placeholder: "This report is under construction.",
  failedLoad: "Failed to load the report",
  failedExport: "Failed to export the report",
  popupBlocked: "Could not open the print window - please allow pop-ups",
  debit: "Debit",
  credit: "Credit",
  balance: "Balance",
  balanced: "Balanced",
  notBalanced: "Not balanced",
  account: "Account",
  accountCode: "Account code",
  accountName: "Account name",
  accountPicker: {
    label: "Account",
    hint: "Search by code or name",
    noResults: "No matching account",
    failedLoad: "Failed to load the chart of accounts",
    forbidden: "You may not view the chart of accounts",
    leafOnlyHint: "Leaf accounts (no children) only",
    inactive: "inactive",
  },
};
